import { Application, SpendingLimits } from '../../Dashboard.types';
import styles from '../SpendingLimitDrawer.module.css';
import { UnavailableLimit } from './UnavailableLimit';
import { Button, Icon } from '@iwoca/orion';
import { daysSinceStatusDate } from '../../Dashboard.helpers';

export const DeclinedLimitDrawer = ({
    spendingLimits,
    refreshSpendingLimit,
    loadingRefreshSpendingLimit,
    isError,
    application
}: {
    spendingLimits: SpendingLimits;
    refreshSpendingLimit: () => Promise<void>;
    loadingRefreshSpendingLimit: boolean;
    isError: boolean;
    application: Application;
}) => {
    const daysSinceDecline = daysSinceStatusDate(application);

    // Don't let them refresh until 30 days after decline.
    // If we don't know how many days since decline, let them try
    const showRefreshButton =
        daysSinceDecline !== null ? daysSinceDecline >= 30 : true;

    return (
        <>
            <div className={styles.spendingLimits}>
                {Object.keys(spendingLimits.limits).map((key) => {
                    return (
                        <UnavailableLimit
                            sellerProduct={
                                key as keyof typeof spendingLimits.limits
                            }
                            key={key}
                        />
                    );
                })}
                {showRefreshButton && (
                    <div>
                        <Button
                            disabled={loadingRefreshSpendingLimit}
                            onClick={refreshSpendingLimit}
                            className={styles.refreshButton}
                        >
                            {loadingRefreshSpendingLimit ? (
                                <>
                                    <Icon
                                        icon="sync"
                                        className={styles.spinningIcon}
                                    />
                                    Checking limits...
                                </>
                            ) : (
                                <>
                                    <Icon icon="sync" />
                                    Secure my limits
                                </>
                            )}
                        </Button>
                        {isError && (
                            <div className={styles.errorMessage}>
                                Something went wrong
                            </div>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};
